import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import Modal from '../Modal';
import { handleDeleteForm } from './service';

const DeleteForm = ({ formId, formName, formGroupingId }) => {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const deleteText = `You are about to delete the form ${formName} (ID: ${formId}).
  \rDoing so will remove it from the Taxi database and, if published, S3 buckets.
  \rIt will remain on any live marketing pages until changed.`;

  const onCancel = () => {
    setShowModal(false);
  };

  const onDeleteClick = () => {
    setShowModal((prev) => !prev);
  };

  const onConfirmDelete = () => {
    handleDeleteForm(dispatch, formId, formGroupingId);
  };

  return (
    <div>
      <button type="button" className="btn btn-danger" onClick={onDeleteClick}>
        Delete Form
      </button>
      {showModal ? (
        <Modal>
          <Modal.Header
            onCancel={onCancel}
          >
            <h5 className="modal-title">Delete Form</h5>
          </Modal.Header>
          <Modal.Body>
            {deleteText}
          </Modal.Body>
          <Modal.Footer>
            <button type="button" className="btn btn-secondary" onClick={onCancel}>Cancel</button>
            <button type="button" id="delete-form-confirm-button" className="btn btn-danger" onClick={onConfirmDelete}>Delete Form</button>
          </Modal.Footer>
        </Modal>
      ) : null}
    </div>
  );
};

DeleteForm.propTypes = {
  formId: PropTypes.string.isRequired,
  formName: PropTypes.string.isRequired,
  formGroupingId: PropTypes.number.isRequired,
};
export default DeleteForm;
